export default __webpack_public_path__ + "static/media/add_dependant_icon.e2375dd7.svg";